import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eye",
  "use": "icon-eye-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-eye\"><defs><style type=\"text/css\"></style></defs><path d=\"M398.592 801.365333l-82.389333-22.101333 33.578666-125.397333a468.821333 468.821333 0 0 1-138.112-79.872l-91.861333 91.904-60.373333-60.373334 91.904-91.861333a467.498667 467.498667 0 0 1-101.162667-216.32l83.968-15.317333C166.528 461.312 323.370667 597.333333 512 597.333333c188.586667 0 345.472-136.021333 377.856-315.306666l83.968 15.274666a467.498667 467.498667 0 0 1-101.12 216.362667l91.861333 91.861333-60.373333 60.373334-91.861333-91.904a468.821333 468.821333 0 0 1-138.112 79.872l33.578666 125.44-82.389333 22.058666-33.621333-125.44a472.405333 472.405333 0 0 1-159.573334 0l-33.621333 125.44z\" p-id=\"3004\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/eye.svg
// module id = 4wdf
// module chunks = 61